import { useEffect, useRef, useState } from 'react';
export function useFollowElementPosition(targetRef, enabled) {
  let offsetY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let offsetX = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  const [position, setPosition] = useState({
    top: 0,
    left: 0,
    width: 0
  });
  const frameIdRef = useRef();
  useEffect(() => {
    if (!enabled || !targetRef.current) return;
    const updatePosition = () => {
      const el = targetRef.current;
      if (el) {
        const {
          top,
          left,
          width
        } = el.getBoundingClientRect();
        setPosition({
          top: top + offsetY,
          left: left + offsetX,
          width
        });
      }
    };
    const loop = () => {
      updatePosition();
      frameIdRef.current = requestAnimationFrame(loop);
    };
    loop();
    return () => {
      if (frameIdRef.current) {
        cancelAnimationFrame(frameIdRef.current);
      }
    };
  }, [enabled, targetRef, offsetY, offsetX]);
  return position;
}